import React from "react";

const UserUploadResponse = ({ UploadResponse, responseType, attachmentName, onEdit }) => {
    // Allow edit for known document types
    const editableTypes = ["upload_pan", "upload_gst", "upload_aadhar", "upload_bank", "upload_itr", "upload_cmp_pan"];
    const isEditable = editableTypes.includes(responseType);

    return (
        <div className="user-typed-response">
            <div className="user-type-response">
                <div className="user-type-response-content">
                    <div className="user-type-response-content-title">
                        {UploadResponse}
                    </div>
                    <div className="user-type-response-content-document">
                        <div>
                            <img src="/images/pdf-icon.png" alt="pdf-icon" />
                        </div>
                        <div>{attachmentName ? attachmentName : "Document"}</div>
                        <div>10Mb</div>
                    </div>
                </div>
                {isEditable && (
                    <div className="user-edit-icon" onClick={onEdit}>
                        <img src="/images/edit-icon.png" alt="edit-icon" />
                    </div>
                )}
            </div>
            <div className="user-profile-icon">
                <img src="/images/profile-icon.png" alt="profile-icon" />
            </div>
        </div>
    );
};

export default UserUploadResponse;